declare namespace $ {

	type $shm_paginator__page_shm_showcase_demo_paginator_1 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_paginator['page'] >
		,
		ReturnType< $shm_paginator['page'] >
	>
	type $shm_paginator__total_shm_showcase_demo_paginator_2 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_paginator['total'] >
	>
	type $shm_paginator__page_shm_showcase_demo_paginator_3 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_paginator['page'] >
		,
		ReturnType< $shm_paginator['page'] >
	>
	type $shm_paginator__total_shm_showcase_demo_paginator_4 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_paginator['total'] >
	>
	export class $shm_showcase_demo_paginator extends $mol_view {
		page( next?: number ): number
		Top( ): $shm_paginator
		Bottom( ): $shm_paginator
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=paginator.view.tree.d.ts.map